import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import ImprintChart from 'components/ImprintChart';
import FavoriteGenresLabels from 'components/FavoriteGenresLabels';
import GridContainer from 'components/Grid/GridContainer.jsx';
import MessageInfo from 'components/MessageInfo';
import GridItem from 'components/Grid/GridItem.jsx';
import Loader from 'components/Loader';
import Style from 'assets/jss/material-dashboard-pro-react/views/chatStyle';
import fyndaGenres from 'config/fyndaGenres';
import countBy from 'lodash/countBy';

const Imprint = ({
  uid,
  classes,
  username,
  favoriteSongs,
  providerToptracks,
}) => {
  const trackList = [].concat(favoriteSongs, providerToptracks || []);

  // Add the genre for each track as defined by Fynda
  // and extract labels and datasets for the user imprint
  const { data, labels, backgroundColor } = useMemo(() => {
    const favorites = trackList.reduce((r, e) => {
      let i = 0;
      let fyndaGenre;
      const parentGenres = Object.keys(fyndaGenres);
      while (!fyndaGenre && parentGenres[i]) {
        const parentGenre = parentGenres[i];
        const { subgenres } = fyndaGenres[parentGenre];
        if (subgenres.includes(e.genre)) {
          fyndaGenre = parentGenre;
        }
        i++;
      }
      if (!fyndaGenre) return r;
      r.push({ ...e, fyndaGenre });
      return r;
    }, []);
    const countByGenre = countBy(favorites, (e) => e.fyndaGenre);
    const labels = Object.keys(countByGenre);
    const data = Object.values(countByGenre);
    const backgroundColor = labels.map((e) => fyndaGenres[e].color);
    return { data, labels, backgroundColor };
  });

  return (
    <div>
      <Card
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '20px 20px 0px 3px',
          width: '117%',
          height: '100vh',
          margin: '30px 0px 0px -30px',
        }}
      >
        {!uid ? (
          <div style={{ marginTop: '40px' }}>
            <Loader />
          </div>
        ) : !trackList.length ? (
          <MessageInfo text={<div>No data available yet</div>} />
        ) : (
          <div>
            <GridContainer
              className={classes.mobileAlbum}
              style={{ width: '100%', padding: '20px 0px 0px 3%' }}
            >
              <GridItem xs={12}>
                <ImprintChart
                  labels={labels}
                  chartSize={300}
                  datasets={[{ data, backgroundColor }]}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem
                style={{
                  width: '100%',
                  margin: '20px',
                  textAlign: 'center',
                }}
              >
                <b style={{ fontSize: '22px' }}>{username}</b>
              </GridItem>
            </GridContainer>
            <GridContainer
              className={classes.mobileAlbum}
              style={{ width: '100%', paddingLeft: '3%' }}
            >
              <GridItem>
                <FavoriteGenresLabels labels={labels} />
              </GridItem>
            </GridContainer>
          </div>
        )}
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { username, favoriteSongs, providerToptracks, uid } = state.user || {};
  return { username, favoriteSongs, providerToptracks, uid };
};

export default compose(connect(mapStateToProps), withStyles(Style))(Imprint);
